import { Icon, IconName } from '~/modules/elements/akui/icon';

/**
 * Some mirrored screens are reads: Achievements, Compare, Calibration, Your score and Vocal range's
 * measuring step register one or two controls between them, and everything worth seeing is on the
 * television. Mirroring them anyway is still right - not mirroring leaves the phone holding the
 * PREVIOUS screen's controls, which is change 12's bug - but a header and a lone button say nothing
 * about what is being looked at.
 *
 * So the screen says where its content is, drawn rather than written: the phone shows a small
 * television holding the screen's own glyph. It reads at a glance and it survives not being read at
 * all. The one real datum goes in `HelpEntry.subtitle` above it, not in here.
 */
export default function OnTelevision({ icon }: { icon: IconName }) {
  return (
    <div className="flex shrink-0 flex-col items-center gap-2.5 py-1.5" data-test="on-television">
      <div className="flex flex-col items-center">
        <div className="flex h-[6.375rem] w-[10.25rem] items-center justify-center rounded-[0.625rem] bg-white/4 shadow-[inset_0_0_0_2px_rgba(255,255,255,0.22)]">
          <Icon icon={icon} size={9} className="text-active/55" />
        </div>
        {/* The stand, so the box reads as a television rather than as an empty card. */}
        <span aria-hidden className="h-2 w-[1.875rem] bg-white/22" />
        <span aria-hidden className="h-1 w-[3.5rem] rounded-sm bg-white/22" />
      </div>
      <span className="text-[0.8125rem] tracking-[0.1em] text-white/42 uppercase">On the television</span>
    </div>
  );
}
